import { Currency } from '@/shared/api';

import { ICurrency } from '../types';

export const serializeCurrency = (currency: Currency): ICurrency => {
  return {
    id: currency.id,
    ticker: currency.ticker,
    symbol: currency.symbol ?? '',
    precision: currency.precision,
    name: currency.item.name,
    code: currency.item.code,
  };
};
